<template>
  <span>
    <img v-for="(number, index) in numbers" :key="index" :src="img(number)" name="slide">
  </span>
</template>
<script>
export default {
  name: 'DisplayResult',
  props: {
    result: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {
    numbers() {
      if(this.result)
        return this.result.split('')

      return []
    }
  },
  methods: {
    img(number) {
      //return require(`@/assets/theme/s${number}.png`)
      return require(`@/assets/${number}.png`)
    }
  }
}
</script>
